<!-- @format -->

<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">Vuexy</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1"> 欢迎 🚀 </b-card-title>
          <b-card-text class="mb-2"> 你可以在这里注册你的账号! </b-card-text>

          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form class="auth-register-form mt-2" @submit.prevent="register">
              <!-- username -->
              <b-form-group label="电子邮件" label-for="register-email">
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  vid="email"
                  rules="required"
                  style="display: flex; justify-content: space-between"
                >
                  <b-form-input
                    style="width: 75%"
                    id="register-email"
                    v-model="email"
                    name="register-email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="请输入电子邮件"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <b-button
                    v-if="text === '发送'"
                    variant="primary"
                    style="width: 24%"
                    :disabled="disable"
                    @click="fs_email"
                  >
                    {{ text }}
                  </b-button>

                  <b-button
                    v-if="text !== '发送'"
                    style="width: 24%"
                    :disabled="disable"
                    @click="fs_email"
                  >
                    {{ text }}
                  </b-button>
                </validation-provider>
              </b-form-group>
              <b-form-group label="验证码" label-for="register-check_code">
                <validation-provider
                  #default="{ errors }"
                  name="check_code"
                  vid="check_code"
                  rules="required"
                >
                  <b-form-input
                    id="register-check_code"
                    v-model="check_code"
                    name="register-check_code"
                    :state="errors.length > 0 ? false : null"
                    placeholder="请输入邮箱验证码"
                  />
                </validation-provider>
              </b-form-group>
              <b-form-group label="姓" label-for="register-username">
                <validation-provider
                  #default="{ errors }"
                  name="real_name"
                  vid="real_name"
                  rules="required"
                >
                  <b-form-input
                    v-model="lastname"
                    name="register-real_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="请输入姓氏"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="名" label-for="register-username">
                <validation-provider
                  #default="{ errors }"
                  name="firstname"
                  vid="firstname"
                  rules="required"
                >
                  <b-form-input
                    v-model="firstname"
                    name="register-real_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="请输入名字"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email -->
              <b-form-group label="手机号码">
                <validation-provider
                  #default="{ errors }"
                  name="mobile"
                  vid="mobile"
                >
                  <b-form-input
                    id="register-mobile"
                    v-model="mobile"
                    name="register-mobile"
                    placeholder="请输入手机号码"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="出生日期">
                <validation-provider
                  #default="{ errors }"
                  name="birth"
                  vid="birth"
                >
                  <flat-pickr
                    v-model="birth"
                    class="form-control invoice-edit-input"
                    placeholder="选择日期"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="国家" label-for="register-country">
                <validation-provider
                  #default="{ errors }"
                  name="country"
                  vid="country"
                >
                  <b-form-input
                    id="register-country"
                    v-model="country"
                    placeholder="请输入国家"
                    name="register-country"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="家庭住址" label-for="register-address">
                <validation-provider
                  #default="{ errors }"
                  name="address"
                  vid="address"
                >
                  <b-form-input
                    id="register-address"
                    v-model="address"
                    name="register-address"
                    placeholder="请输入地址"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- 新增的玩意 -->

              <b-form-group label="家庭住址2" label-for="register-address2">
                <validation-provider
                  #default="{ errors }"
                  name="address2"
                  vid="address2"
                >
                  <b-form-input
                    id="register-address2"
                    v-model="address2"
                    name="register-address2"
                    placeholder="请输入地址"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="城市" label-for="register-city">
                <validation-provider
                  #default="{ errors }"
                  name="city"
                  vid="city"
                >
                  <b-form-input
                    id="register-city"
                    v-model="city"
                    name="register-city"
                    placeholder="请输入城市"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="州" label-for="register-state">
                <validation-provider
                  #default="{ errors }"
                  name="state"
                  vid="state"
                >
                  <b-form-input
                    id="register-state"
                    v-model="state"
                    name="register-state"
                    placeholder="请输入州"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="邮政编码" label-for="register-post_code">
                <validation-provider
                  #default="{ errors }"
                  name="post_code"
                  vid="post_code"
                >
                  <b-form-input
                    id="register-post_code"
                    v-model="post_code"
                    name="register-post_code"
                    placeholder="请输入邮政编码"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- <b-form-group label="性别" label-for="register-gender">
                <validation-provider
                  #default="{ errors }"
                  name="gender"
                  vid="gender"
                >
                  <v-select
                    v-model="gender"
                    :placeholder="'请选择性别'"
                    :options="sex"
                    :options-label="'label'"
                    :options-value="'value'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->
              <b-form-group label="邀请码" label-for="register-pid">
                <validation-provider #default="{ errors }" name="pid" vid="pid">
                  <b-form-input
                    id="register-pid"
                    v-model="pid"
                    name="register-pid"
                    placeholder="请填写邀请码"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
              <b-form-group label-for="register-password_hash" label="密码">
                <validation-provider
                  #default="{ errors }"
                  name="password_hash"
                  vid="password_hash"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="register-password_hash"
                      v-model="password_hash"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false : null"
                      name="register-password_hash"
                      placeholder="请输入密码"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group />
              <!-- 返回登录 -->
              <b-card-text class="text-center mt-2">
                <span>已有账号? </span>
                <b-link :to="{ name: 'auth-login' }">
                  <span>&nbsp;返回登录</span>
                </b-link>
              </b-card-text>

              <b-button variant="primary" block type="submit"> 提交 </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    vSelect,
    ValidationObserver,
    BButton,
    flatPickr,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      fs_status: 'false',
      real_name: '',
      address: '',
      birth: '',
      rangePicker: ['2019-05-01', '2019-05-10'],
      gender: 0,
      pid: null,
      text: '发送',
      time: 60,
      timer: null,
      disable: false,
      password_hash: '',
      mobile: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email: '',
      country: '',
      num: 60,
      check_code: '',
      lastname: '',
      name: '',
      firstname: '',
      address2: '',
      state: '',
      city: '',
      post_code: '',
      sex: [
        {
          label: '男',
          value: 1,
        },
        {
          label: '女',
          value: 2,
        },
      ],
      tuijian: [
        {
          label: '1号',
          value: 1,
        },
        {
          label: '2号',
          value: 2,
        },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    const time = localStorage.getItem('time')
    // 判断是否大于0
    if (time && time > 0) {
      //  解决刷新页面按钮有空白情况
      this.text = `${time}秒`
      this.time = time
      this.send()
    }
  },
  methods: {
    send() {
      // 点击按钮，禁用按钮，防止多次点击
      this.disable = true
      this.text = `${this.time}s`
      localStorage.setItem('time', this.time)
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
          localStorage.setItem('time', this.time)
          this.text = `${this.time}s`
        } else {
          clearInterval(this.timer)
          this.time = 60
          this.disable = false
          this.text = '发送'
        }
      }, 1000)
    },

    fs_email() {
      console.log(this.firstname, this.lastname)
      if (this.firstname == '' && this.lastname == '') {
        this.$toast('请先填写姓名')
      } else {
        this.name = this.firstname + this.lastname
        useJwt
          .fs_email({ email: this.email, firstname: this.name })
          .then(response => {
            console.log(response)
            if (response.code == 0) {
              this.send()
            } else {
              this.$toast('发送错误，请正确填写邮箱')
            }
          })
      }
    },
    register() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          useJwt
            .register({
              email: this.email,
              mobile: this.mobile,
              // real_name: this.real_name,
              firstname: this.firstname,
              lastname: this.lastname,
              country: this.country,
              birth: this.birth,
              address: this.address,
              gender: this.gender.value,
              password_hash: this.password_hash,
              pid: this.pid,
              check_code: this.check_code,
              address2: this.address2,
              state: this.state,
              city: this.city,
              post_code: this.post_code,
            })
            .then(response => {
              if (response.code == 0) {
                this.$toast('注册成功')
                setTimeout(this.$router.push('/login'), 2000) // 返回login
              } else if (response.code == -1) {
                this.$toast(response.msg)
              }
            })
            .catch(error => {
              this.$refs.registerForm.setErrors(error.response.data.error)
            })
        }
      })
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
.xz_birth {
  width: 100%;
  height: 38px;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
</style>
